
  import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
  import iconHandler from './icon-handler.vue';

  @Component({
    components: {
      iconHandler,
    },
  })
  export default class MjButton extends Vue {
    @Prop({type: Object, default: {}}) private element!: any;

    private text: string = 'Example text';
    private dialog: boolean = false;
    private settings: any = {
      'padding-top': '0px',
      'padding-bottom': '0px',
      'padding-left': '0px',
      'padding-right': '0px',
      'background-color': '#414141',
      'href': '',
      'color': '#ffffff',
    };

    private editElement() {
      this.dialog = true;
    }

    private created() {
      this.text = this.element.data;
      this.settings = this.element.settings;
    }

    @Watch('dialog')
    private updatedDialog() {
      this.$emit('updateSettings', this.settings);
    }
    @Watch('text')
    private updatedText() {
      this.$emit('updateContent', this.text);
    }
  }
